/*个人申报明细报表 */
import { $http, buildHeaders } from "./index";

//获取列表
export const taxfinalsettlement_list = (params) => {
  return $http.get("/admin/TaxFinalSettlement/index", { params });
};

//获取汇算清缴报表列表员工详情
export const taxfinalsettlement_detail = (params) => {
  return $http.get("/admin/TaxFinalSettlement/detail", { params });
};

//导出
export const taxfinalsettlement_export = (params) => {
  return $http.get("/admin/TaxFinalSettlement/export", {
    params,
    responseType: "blob",
    headers: buildHeaders(1, "正在下载文件，请稍后……"),
  });
};

//从税局下载汇算清缴数据
export const taxfinalsettlement_pull = (data) => {
  return $http.post("/admin/TaxFinalSettlement/pull", data, {
    headers: buildHeaders(3),
  });
};

//从税局下载汇算清缴测一测数据
export const taxfinalsettlement_pullscan = (data) => {
  return $http.post("/admin/TaxFinalSettlement/pullScan", data, {
    headers: buildHeaders(3),
  });
};
